import React from "react";
import Routers from "./Routers/routes";
import { Toaster } from "react-hot-toast";



function App() {
  return (
    <div className="App">
      <Toaster />
      <Routers />
    </div>
  );
}

export default App;
